import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

interface Props {
  checked?: boolean;
  onClick?: (e: ElementMouseEvent) => void;
}

// eslint-disable-next-line react/prefer-stateless-function
class Checkbox extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <div
        className={classNames({
          'step-checkbox': true,
          checked: this.props.checked,
        })}
        onClick={this.props.onClick}
      >
        <BenchlingIcon icon="check" />
      </div>
    );
  }
}

export default Checkbox;
